import { useQueryClient } from '@tanstack/react-query';

import { getApiV1PersonQueryOptions, useDeleteApiV1PersonId } from '@/shared/api/generated';

/**
 * Hook para excluir uma pessoa.
 *
 * Tenta exclusão permanente; se houver dependências, desativa a pessoa (soft delete).
 * Invalida a listagem após operação bem-sucedida.
 *
 * @example
 * ```tsx
 * const deletePerson = useDeletePerson();
 * deletePerson.mutate({ id: 1 });
 * ```
 */
export function useDeletePerson() {
  const queryClient = useQueryClient();

  return useDeleteApiV1PersonId({
    mutation: {
      onSuccess: () => {
        void queryClient.invalidateQueries(getApiV1PersonQueryOptions());
      },
    },
  });
}
